import './PipelineSteps.css';

const STEPS = [
  { num: '01', label: 'NORMALISE',  desc: 'Cleaning CV text...',             color: '#6366f1' },
  { num: '02', label: 'EXTRACT',    desc: 'Extracting structured data...',   color: '#0ea5e9' },
  { num: '03', label: 'ANALYSE JD', desc: 'Analysing job description...',    color: '#f59e0b' },
  { num: '04', label: 'TAILOR',     desc: 'Tailoring your CV...',            color: '#10b981' },
  { num: '05', label: 'VERIFY',     desc: 'Running integrity audit...',      color: '#ef4444' },
];

export default function PipelineSteps({ activeStep }) {
  return (
    <div className="pipeline-wrap">
      {STEPS.map((step, i) => {
        const stepNum = i + 1;
        const isDone    = activeStep > stepNum;
        const isActive  = activeStep === stepNum;
        const isPending = activeStep < stepNum;

        return (
          <div key={i} className="pipeline-row">
            <div className={`step-card ${isActive ? 'active' : ''} ${isDone ? 'done' : ''} ${isPending ? 'pending' : ''}`}
              style={{ '--step-color': step.color }}>
              <div className="step-num-wrap">
                {isDone ? (
                  <div className="step-check">✓</div>
                ) : isActive ? (
                  <div className="step-spinner" />
                ) : (
                  <div className="step-num">{step.num}</div>
                )}
              </div>
              <div className="step-info">
                <div className="step-label">{step.label}</div>
                <div className="step-desc">
                  {isDone ? 'Complete' : isActive ? step.desc : 'Waiting...'}
                </div>
              </div>
              {isActive && <div className="step-pulse" />}
            </div>
            {i < STEPS.length - 1 && (
              <div className={`step-connector ${isDone ? 'done' : ''}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
